//@flow
import React from 'react';
import s from './AdditionalInfo.less';

type Props = {
  additionalInfo: Object,
  sectionTitle?: string,
};

const AdditionalInfo = (props: Props) => (
  <div className={`${s.additionalInfoWrapper}`}>
    {Object.keys (props.additionalInfo).map (property => {
      return (
        <p className={`${s.additionalInfo}`} key={property}>
          <span className={`${s.property}`}>{property}</span>
          :
          <span
            data-e2e={`${props.sectionTitle && property === 'Reference Date' ? props.sectionTitle.replace (/ /g, '-') + '-' : ''}${property.replace (/ /g, '-')}`}
          >
            {' '}{props.additionalInfo[property]}
          </span>
        </p>
      );
    })}
  </div>
);

export const AdditionalInfoSubSection = (props: Props) => (
  <div className={`${s.additionalInfoSubsectionWrapper}`}>
    {Object.keys (props.additionalInfo).map (property => {
      return (
        <p className={`${s.additionalInfo}`} key={property}>
          <span className={`${s.property}`}>{property}</span>
          :
          <span
            data-e2e={`${props.sectionTitle && property === 'Reference Date' ? props.sectionTitle.replace (/ /g, '-') + '-' : ''}${property.replace (/ /g, '-')}`}
          >
            {' '}{props.additionalInfo[property]}
          </span>
        </p>
      );
    })}
  </div>
);

export default AdditionalInfo;



// WEBPACK FOOTER //
// ./src/components/SummarySubSections/SummarySubSection/AdditionalInfo/AdditionalInfo.js